{
	"povzetek": {
		"title": "Povzetek",
		"skupno30": "Zadnjih 30 dni",
		"skupno90": "Zadnjih 90 dni",
		"skupno365": "Zadnjih 365 dni",
		"vsiO": "Vsi opravljeni leti",
		"povprecje": "Povprečna dolžina leta",
		"najveckratV": "Največkrat leteno letalo"
	},
	"table": {
		"datum": "Datum",
		"letalisce":"Letališče",
		"ttof":"TTOF",
		"vzlet":"Vzlet",
		"diaryTitle": "Dnevniški zapisi"
	},
	"modal": {
		"datum":"Datum:",
		"casL":"Celotni čas letenja:",
		"pristankiD":"št. Pristankov (dan):",
		"pristankiN":"št. Pristankov (noč):",
		"op":"Operativni pogoji:",
		"vp":"Vloga pilota:",
		"fstd":"Čas FSTD:",
		"odhod":"Odhod:",
		"krajO":"Kraj odhoda:",
		"prihod":"Prihod:",
		"krajP":"Kraj prihoda:",
		"zrakoplov":"Zrakoplov:",
		"reg":"Registracija: ",
		"vodjaZ":"Ime vodje zrakoplova:",
		"opomba":"Opomba:"
	},
	"labels": {
		"casO":"Čas odhoda:",
		"casP":"Čas prihoda:",
		"model":"Model zrakoplova:",
		"reg":"Registracija zrakoplova:",
		"vodjaZ":"Ime vodje zrakoplova:",
		"posadka": "Enočlanska / Veččlanska posadka :",
		"pogoji":"Pogoji letenja:",
		"pD":"Dan",
		"pN":"Noč",
		"stPristankov":"Št. pristankov:",
		"ttof":" Ttof:",
		"op":"Operativni pogoji :",
		"opD":"Dnevno",
		"opN":"Nočno",
		"vp":"Vloga pilota:",
		"fstd":"Čas FSTD:",
		"opomba":"Opomba:",
		"pristanek": "Izberi pristanek :",
		"regL": "Izberi reg. jadralnega letala :"
	},
	"buttons": {
		"urediPodatke":"Uredi podatke",
		"posodobiPodatke":"Posodobi podatke",
		"brisiZapis":"Izbriši zapis",
		"brisiIzbiro":"Pobriši izbiro",
		"natisni": "Natisni",
		"poslji": "Pošlji"
	}
}